"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _CarouselImage = _interopRequireDefault(require("./CarouselImage"));

require("slick-carousel/slick/slick.css");

require("slick-carousel/slick/slick-theme.css");

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Carousel =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Carousel, _React$Component);

  var _super = _createSuper(Carousel);

  function Carousel() {
    (0, _classCallCheck2["default"])(this, Carousel);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Carousel, [{
    key: "render",
    value: function render() {
      var settings = {
        dots: true,
        appendDots: function appendDots(dots) {
          return (
            /*#__PURE__*/
            _react["default"].createElement("ul", {
              style: {
                margin: "0px"
              }
            }, " ", dots, " ")
          );
        },
        arrows: false,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: "linear",
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000
      };
      return (
        /*#__PURE__*/
        _react["default"].createElement("div", null, this.props.data !== null &&
        /*#__PURE__*/
        _react["default"].createElement(_reactSlick["default"], settings, this.props.data.images.map(function (image) {
          return (
            /*#__PURE__*/
            _react["default"].createElement(_CarouselImage["default"], {
              image: image.image,
              title: image.title,
              text: image.text
            })
          );
        })))
      );
    }
  }]);
  return Carousel;
}(_react["default"].Component);

var _default = Carousel;
exports["default"] = _default;